<template>
  <div :id="this.id"
       :class="'sitebuilder-element-container'  + hideControl()"
       element="ImageComponent"
       :data-hide-desktop="!this.internal_config.showDesktop"
       :data-hide-mobile="!this.internal_config.showMobile"
       :style="style()">


      <v-lazy-image ref="image" :src="this.internal_config.src" @click="linkAction()"
            alt="" class="sitebuilder-element"
           v-bind:style="{opacity: opacity,'border-radius': radius, border : border, 'box-shadow': boxShadow,}">
      </v-lazy-image>
  </div>
</template>

<script>

	import {SweetModal} from 'sweet-modal-vue'
	import ImageData from './Model';
	import Resources from './Resources.vue';
	// import VueDraggableResizable from 'vue-draggable-resizable'

	export default {
		name: 'ImageComponent',
		props: ['config', 'src', 'id', 'preview'],
		components: {
			SweetModal,
			ImageData,
			Resources,
		},
		computed: {
			opacity() {
				return this.internal_config.opacity;
			},
			border() {
				return this.internal_config.border;
			},
			boxShadow() {
				return this.internal_config.boxShadow;
			},
			radius() {
				return this.internal_config.borderRadius;
			},
		},
		data() {
			return ImageData.data();
		},
		methods: {

            hideControl(){
                var classAdd = '';
                if(!this.internal_config.showMobile){
                    classAdd = classAdd + ' hide-on-mobile'
                }

                if(!this.internal_config.showDesktop){
                    classAdd = classAdd + ' hide-on-desktop'
                }

                return classAdd;
            },

			build(config) {
				this.internal_config = config;
			},

			linkAction: function () {


				// if (this.internal_config.link.type === 'video' && this.internal_config.link.value !== '') {
				//   this.$refs.videoModalIframe.src = this.internal_config.link.value;
				//   this.$refs.videoModal.open();
				// } else {
				this.$root.$emit('linkAction', this.internal_config.link);
				// }

			},
			style() {
				var style = `width: ${this.internal_config.width};
                     height:  ${this.internal_config.height};
                     padding-top: ${this.internal_config.paddingTop};
                     padding-left: ${this.internal_config.paddingLeft};
                     z-index: ${this.internal_config.zIndex};
                     padding-right: ${this.internal_config.paddingRight};
                     padding-bottom: ${this.internal_config.paddingBottom};
                     margin-left: ${this.internal_config.marginLeft};
                     margin-right: ${this.internal_config.marginRight};
                     left:  ${this.internal_config.left};
                     top: ${this.internal_config.top}`;
				return style;
			},
			styleResize() {
				return `{width: ${this.internal_config.width}, height:  ${this.internal_config.height}}`;
			},
			handler: function (e) {

				// this.$el.classList.add('animated', 'jello', 'infinite');

				this.$root.$emit('focusElement', this);
				this.$root.$emit('handlerElement', this);
				e.stopPropagation();
				e.preventDefault();
			},
			hover() {
				this.$emit('highlightHover', {name: this.name, posicao: this.$refs.image.getBoundingClientRect()});
			}
		},
		mounted() {

			this.build(this.$props.config);

			Object.keys(this.props).forEach(prop => {
				if (typeof this.internal_config[prop] === 'undefined') {
					this.internal_config[prop] = this.props[prop];
				}
			});

				this.$root.$emit('applyAnimation', this, 'sitebuilder-element-container');

		}
	}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >
    [element="ImageComponent"] img {
    width: 100%;
    height: auto;
  }

  .resizable.vdr {
    width: 100% !important;
    height: 100% !important;
    left: 0 !important;
    top: 0 !important;
  }

</style>
